import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Switch, Route, useLocation } from "react-router-dom";

import MainHeader from "./../components/MainHeader";
import { Footer } from "../components/Footers";
import Home from "./sections/Home";
import Contact from "./sections/Contact";

const Landing = (props) => {
	let location = useLocation();

	const pages = [
		{ href: "/", text: "Inicio" },
		{ href: "#nosotros", text: "Nosotros" },
		{ href: "#servicios", text: "Servicios" },
		{ href: "#talleres", text: "Talleres" },
		{ href: "#contacto", text: "Contacto" },
	];

	const getNavigationMenu = () => {
		return (
			<Navbar bg="light" expand="md">
				<Navbar.Toggle className="m-auto" aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="m-auto">
						{pages.map((page, idx) => (
							<Nav.Link key={`nav-item-${idx}`} active={page.href === location.pathname} href={page.href}>
								{page.text}
							</Nav.Link>
						))}
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		);
	};

	return (
		<div className="page-content">
			<MainHeader />
			<main>
				{getNavigationMenu()}
				<Switch>
					<Route path="/" exact component={Home} />
					<Route path="/nosotros" exact component={Home} />
					<Route path="/servicios" exact component={Home} />
					<Route path="/talleres" exact component={Home} />
					<Route path="/contacto" exact component={Home} />
				</Switch>
				<Contact id="contacto" />
			</main>
			<Footer corporation="Prolitigio" />
		</div>
	);
};

export default Landing;
